type Props = {
  title: string;
};

export default function FloorPlanViewerFooter({title}: Props) {
  return (
    <div className="bg-black absolute overflow-hidden right-0 left-0 bottom-0 text-center">
      <div className="text-white inline-block float-left text-3xl my-5 mx-[5%] overflow-hidden opacity-100 text-left text-ellipsis transition-opacity duration-150 whitespace-nowrap w-full leading-[1]">
        {title}
      </div>
    </div>
  );
}
